import { getSystemEnv } from '@/utils/env'
import axios from 'axios'

export const cmsCLient = axios.create({
  baseURL: getSystemEnv().CMS_API_URL
})
export const shopCLient = axios.create({
  baseURL: getSystemEnv().MCOMMERCE_URL
})
export const mobiClient = axios.create({
  baseURL: getSystemEnv().MOBI_API_URL
})
export const vipClient = axios.create({
  baseURL: getSystemEnv().MOBI_API_URL
})
export const networkCoverageClient = axios.create({
  baseURL: getSystemEnv().NETWORK_COVERAGE_URL
})
